import styled from 'styled-components';

export const ResponsiveWrapper = styled.div<{
  displayFor?: 'desktop' | 'mobile';
}>`
  display: ${({ displayFor }) => (displayFor === 'desktop' ? 'none' : 'flex')};
  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    display: ${({ displayFor }) =>
      displayFor === 'desktop' ? 'flex' : 'none'};
  }
`;

export const TabletWrapper = styled.div<{
  display?: 'flex' | 'block';
  reverse?: boolean;
}>`
  display: ${({ reverse, display }) => (reverse ? display : 'none')};
  ${({ theme }) => theme.mediaQueries.TABLET} {
    display: ${({ display, reverse }) => (reverse ? 'none' : display)};
  }
`;

ResponsiveWrapper.defaultProps = {
  displayFor: 'desktop',
};

TabletWrapper.defaultProps = {
  display: 'flex',
};
